import React from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import AppleLogo from '../../assets/images/apple.png';

type Props = {
  onClick: () => void;
  disabled: boolean;
  isLogin: boolean;
};

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 16,
    height: 21,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(),
  },
  grow: {
    width: 10,
  },
}));

export default function AppleButton({ onClick, disabled, isLogin }: Props) {
  const classes = useStyles();

  if (!onClick) {
    return null;
  }

  return (
    <Button
      variant="contained"
      size="large"
      fullWidth
      onClick={onClick}
      className={classes.container}
      disabled={disabled}
    >
      <img src={AppleLogo} className={classes.logo} alt="apple" />
      {isLogin ? 'Log In with Apple' : 'Sign Up with Apple'}
      <div className={classes.grow} />
    </Button>
  );
}
